import { Link } from "react-router-dom";
import { figures } from "@/mocks/figures";

const stats = [
  { value: "24", label: "正在追踪的人物档案" },
  { value: "68", label: "已厘清的关系链" },
  { value: "5", label: "每周滚动更新的动态" },
];

const featured = figures.find((f) => f.id === 2) ?? figures[0];

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div
        className="pointer-events-none absolute inset-0 opacity-60"
        style={{
          backgroundImage:
            "radial-gradient(60% 60% at 85% 10%, oklch(0.92 0.05 30 / 0.35), transparent 60%), radial-gradient(50% 50% at 5% 90%, oklch(0.92 0.035 155 / 0.4), transparent 60%)",
        }}
      ></div>

      <div className="relative mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold tracking-wide text-primary-700">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
              最新爆料 · 人物追踪栏目
            </p>
            <h1 className="mt-6 font-display text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
              每一桩热点，
              <br />
              都有它的<span className="text-primary-600">新主角</span>
              与新面孔
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
              当新爆料浮出水面，真正让事情变得立体的是人。我们以人物档案的方式，逐一聚焦新面孔、新涉事者与新当事人，厘清谁是新主角、彼此有何关联，并持续追踪最新动态。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/renwu"
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                浏览人物档案库
                <i className="ri-arrow-right-line ml-1.5"></i>
              </Link>
              <button
                type="button"
                onClick={() =>
                  document
                    .getElementById("dynamics")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-center text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-50"
              >
                查看最新动态
              </button>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
              {stats.map((s) => (
                <div key={s.label}>
                  <dt className="sr-only">{s.label}</dt>
                  <dd className="font-display text-2xl font-bold text-primary-600 md:text-3xl">
                    {s.value}
                  </dd>
                  <dd className="mt-1 text-xs leading-relaxed text-secondary-700">
                    {s.label}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="flex flex-col gap-4">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20abstract%20collage%20artwork%20on%20warm%20cream%20paper%2C%20layered%20overlapping%20translucent%20newspaper%20pages%20with%20ink%20typography%20and%20silhouettes%20of%20people%2C%20vermilion%20red%20and%20deep%20pine%20green%20color%20accents%2C%20subtle%20paper%20grain%20texture%2C%20modern%20magazine%20art%20direction%2C%20clean%20minimalist%20composition&width=900&height=1125&seq=hero-editorial-fig&orientation=portrait"
                alt="编辑风抽象拼贴封面，反映最新爆料中的人物追踪主题"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-5 pt-16">
                <p className="text-xs font-semibold tracking-widest text-background-50/80">
                  焦点滚动 · 回应与进展
                </p>
                <p className="mt-1 font-display text-lg font-bold text-background-50">
                  {featured.name}
                </p>
                <Link
                  to={`/renwu/${featured.id}`}
                  className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-background-50/90 hover:text-background-50"
                >
                  阅读最新档案
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
            <p className="text-center text-xs text-secondary-700">
              编辑部以人物档案还原每一桩爆料的完整脉络
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}